export default {
    searchBy: 'ค้นหาด้วยชื่อกลุ่ม',
    search: 'ค้นหา',
    createGroup: 'สร้างกลุ่ม',
    groupName: 'ชื่อกลุ่ม',
    updateAt: 'อัปเดตเมื่อ',
    createdAt: 'สร้างเมื่อ',
    workDay: 'วันทำงาน',
    numberOfPeople: 'จำนวนพนักงาน',
    deleteGroup: 'ลบกลุ่ม',
    congratulation: 'ยินดีด้วย',
    msgDeleteSuccess: 'กลุ่มถูกลบเเล้ว',
    questionDelete: 'คุณเเน่ใจว่าต้องการที่จะลบกลุ่ม "$Name" ?'
}
